import axios from "axios";
import React, { useState, useEffect, useMemo, useRef } from "react";
import rateLimit from 'axios-rate-limit';
import cookie from 'react-cookies';

  const getToken = () => {
    return (cookie.load('token'));
  };
  
  const http_request = (token) => {

    let local_token;
    if (token === ""){
      local_token = getToken()      
    }
    else {
      local_token = token      
    }
    return rateLimit(axios.create({
      
      baseURL: process.env.REACT_APP_BACKEND_URL,
      headers: {
            "Authorization": "Bearer " + local_token,
          "Content-Type": "application/json",
          "Accept": "*/*"
      }
    }), 
    { maxRequests: 5, perMilliseconds: 1000, maxRPS: 5 }); //Rate to be confirmed. In reality, maxRequests = 5 <=> 7 requests/sec. But OK because <10 req/sec.
  }

export default http_request;